import { V2Empty } from '../V2Empty.jsx';
import { EntityChip } from '../EntityChip.jsx';
import { Avatar } from '../Avatar.jsx';

export function V2Entities({ entities }) {
  if (!entities.length) return <V2Empty message="No entities referenced yet." />;

  const byType = {};
  for (const e of entities) {
    (byType[e.type] = byType[e.type] || []).push(e);
  }

  return (
    <div className="v2-entities" data-testid="v2-entities">
      {Object.entries(byType).map(([type, items]) => (
        <div key={type} className="v2-entity-group">
          <div className="v2-entity-type-head">{type}</div>
          {items.map(item => (
            <div key={item.urn} className="v2-entity-row">
              <Avatar name={item.urn.split(':').pop()} size={18} />
              <EntityChip urn={item.urn} compact />
              {item.firstSeenSeq != null && (
                <span className="v2-entity-seq dim">seq {item.firstSeenSeq}</span>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
